export function sortUrl(currentUrl, value) {
  const url = new URL(currentUrl, 'http://localhost');
  url.searchParams.delete('page');
  url.searchParams.set('sort_by', value);
  return url.toString();
}

function setupFacetGrid() {
  const root = document.querySelector('[data-facet-root]');
  if (!root) return;
  root.classList.remove('is-no-js');

  const hide = document.querySelector('[data-facet-hide]');
  if (hide) {
    hide.addEventListener('click', () => {
      const hidden = root.classList.toggle('is-filters-hidden');
      hide.setAttribute('aria-expanded', String(!hidden));
      hide.textContent = hidden ? 'Show filters' : 'Hide filters';
    });
  }

  const drawerOpen = document.querySelector('[data-facet-drawer-open]');
  const drawerCloses = document.querySelectorAll('[data-facet-drawer-close]');
  const overlay = document.querySelector('[data-facet-drawer-overlay]');
  let previousOverflow = '';

  const closeDrawer = () => {
    if (!root.classList.contains('is-drawer-open')) return;
    root.classList.remove('is-drawer-open');
    document.body.style.overflow = previousOverflow;
  };

  if (drawerOpen) {
    drawerOpen.addEventListener('click', () => {
      previousOverflow = document.body.style.overflow;
      root.classList.add('is-drawer-open');
      document.body.style.overflow = 'hidden';
    });
  }
  for (const drawerClose of drawerCloses) {
    drawerClose.addEventListener('click', closeDrawer);
  }
  if (overlay) overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') closeDrawer();
  });

  for (const sort of document.querySelectorAll('[data-facet-sort]')) {
    sort.addEventListener('click', event => {
      event.preventDefault();
      const currentLocation = window.location ?? location;
      currentLocation.href = sortUrl(currentLocation.href, sort.dataset.facetSort);
    });
  }
}

if (typeof document !== 'undefined') setupFacetGrid();
